import { render } from "./PromocionesProductos.vue?vue&type=template&id=419b7668&scoped=true"
import script from "./PromocionesProductos.vue?vue&type=script&lang=js"
export * from "./PromocionesProductos.vue?vue&type=script&lang=js"

import "./PromocionesProductos.vue?vue&type=style&index=0&id=419b7668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419b7668"]])

export default __exports__